var _desc, _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n\t\t\tCreated with Pixso.\n\t")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector 474",
    d: "M19.46 4.05C20.14 4.82 20.18 5.97 19.55 6.79L11.68 17.15C10.83 18.28 9.16 18.28 8.31 17.15L0.44 6.79C-0.19 5.97 -0.15 4.82 0.53 4.05L3.45 0.72C3.86 0.26 4.44 0 5.04 0L8.1 0L12.12 0L14.95 0C15.55 0 16.13 0.26 16.54 0.72L19.46 4.05ZM0.43 5.38L5.74 5.38L14.25 5.38L19.56 5.38M12.12 0L14.25 5.38M5.74 5.38L10 17.76L14.25 5.38M8.1 0L5.74 ",
    stroke: "#0478FE",
    strokeOpacity: 1,
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg01);
export default __webpack_public_path__ + "static/media/01.16cacdad2439c17beb4bcc67ba9b6831.svg";
export { ForwardRef as ReactComponent };